<p>attendance-details works!</p>
